import _ from 'lodash';
(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("WebinarRegistrantsListCtrl", ["webinarsResource", "frameworkService", "messageService", "DTOptionsBuilder", "$sessionStorage", "$translate", "$compile", "$q", "$state", "$filter", "$scope", "$timeout", "$uibModal", webinarRegistrantsListCtrl]);
    function webinarRegistrantsListCtrl(webinarsResource, frameworkService, messageService, DTOptionsBuilder, $sessionStorage, $translate, $compile, $q, $state, $filter, $scope, $timeout, $uibModal) {
        var vm = this;
        vm.lang = $translate.proposedLanguage() || $translate.use();
        var selectAllHtml = "<pretty-checkbox ng-click='vm.updateAllCheckBoxes()' label='false' ng-model='vm.selectAll' class='pretty-checkbox-table'/><div class='clearfix'></div>";
        vm.learnerListModel = [];
        vm.organizationEnabled = frameworkService.data.tenantFeatures.organization;
        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            vm.allItemsMap = {};
            return $q(function (resolve) {
                var promise = webinarsResource.getRegisteredLearnersViewModel({ id: $state.params.id }).$promise;
                promise.then(function (data) {
                    vm.learnerListModel = _.map(data, function (item) {
                        return item;
                    });
                    $scope.$parent.vm.learnerListModel = vm.learnerListModel;
                    resolve(data);
                });
            });
        })
            .withOption("createdRow", function (row, data) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
            row.id = data.personSeq;
        })
            .withOption("headerCallback", function (header) {
            if (!vm.headerCompiled) {
                // Use this headerCompiled field to only compile header once
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        })
            .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
            .withOption("processing", true)
            .withOption("responsive", { details: { type: "column" } })
            .withOption("stateSave", true)
            .withOption("stateDuration", -1)
            .withOption("rowCallback", rowCallback)
            .withOption("lengthChange", false)
            .withOption("info", false)
            .withOption("order", [2, "asc"])
            .withOption("fnDrawCallback", function () {
            $timeout(function () {
                vm.resetTheSelectedRows();
            });
        })
            .withBootstrap();
        vm.dtColumns = [
            {
                "data": null,
                "defaultContent": "",
                "class": "control",
                "sortable": false,
                "targets": 0
            },
            {
                "render": function (data, type, full) {
                    vm.allItemsMap[full.personSeq] = {
                        registrant: full, checked: false
                    };
                    return "<pretty-checkbox name='checkBox' label='false' ng-model='vm.allItemsMap[" + full.personSeq + "].checked' ng-click='vm.itemChecked()' class='pretty-checkbox-table clearfix'></pretty-checkbox>";
                },
                "sortable": false,
                "title": selectAllHtml
            },
            {
                "data": "personSeq",
                "title": $translate.instant("common.regNo")
            },
            {
                "data": "name",
                "title": $translate.instant("common.lists.learner")
            },
            {
                "data": "email",
                "sortable": false,
                "title": $translate.instant("common.lists.email")
            },
            {
                "data": "phone",
                "sortable": false,
                "title": $translate.instant("common.lists.phone")
            },
            {
                "data": "attended",
                "sortable": false,
                "class": "text-center",
                "title": $translate.instant("common.lists.attended"),
                "render": function (data) {
                    return $filter("checkboxIcon")(data);
                }
            }
        ];
        if (vm.organizationEnabled) {
            vm.dtColumns.splice(-1, 0, {
                "data": "organization",
                "title": $translate.instant("common.lists.organization"),
                "sortable": false,
            });
        }
        function rowCallback(nRow, data) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $("td:not(.control)", nRow).unbind("click");
            $("td:not(.control)", nRow).bind("click", function (e) {
                var element = $(e.target);
                if (element.attr("name") === "checkBoxTd" || element.parent().attr("name") === "checkBox")
                    return;
                element.bind("click", vm.rowClicked(data));
            });
            return nRow;
        }
        vm.rowClicked = function (learner) {
            vm.allItemsMap[learner.personSeq].checked = !vm.allItemsMap[learner.personSeq].checked;
            $scope.$apply();
        };
        if ($sessionStorage.registrantFilter) {
            vm.dtSearch = $sessionStorage.webinarRegistrantFilter.search;
        }
        else {
            vm.dtSearch = "";
        }
        vm.search = function (value) {
            $sessionStorage.webinarRegistrantFilter = {
                search: vm.dtSearch
            };
            vm.dtInstance.DataTable.search(value).draw();
        };
        vm.dtInstanceCallback = function (instance) {
            vm.dtInstance = instance;
        };
        vm.resetTheSelectedRows = function () {
            for (var key in vm.allItemsMap) {
                if (vm.allItemsMap.hasOwnProperty(key)) {
                    vm.allItemsMap[key].checked = false;
                }
            }
            vm.selectAll = false; //clear the select all check box
        };
        vm.updateAllCheckBoxes = function () {
            for (var id in vm.allItemsMap) {
                if (vm.allItemsMap.hasOwnProperty(id)) {
                    if ($("#" + id).is(":visible")) {
                        vm.allItemsMap[id].checked = vm.selectAll;
                    }
                }
            }
        };
        vm.itemChecked = function () {
            var registrants = _.where(vm.allItemsMap, {
                checked: false
            });
            vm.selectAll = registrants.length < 1;
        };
        vm.selectedRegistrantIds = function () {
            var registrants = _.where(vm.allItemsMap, {
                checked: true
            });
            return _.pluck(_.pluck(registrants, "registrant"), "id");
        };
        vm.noItemsSelected = function () {
            return _.where(vm.allItemsMap.hasOwnProperty("checked"), {
                checked: true
            }).length === 0;
        };
        vm.updateData = function (data) {
            vm.dtInstance.reloadData($q(function (resolve) {
                resolve(data);
            }));
        };
        //---Add Registrants--------------
        //EXAMPLE Pass input data to modal component (part 1)
        vm.addRegistrants = function () {
            var modalInstance = $uibModal.open({
                component: "addWebinarRegistrants",
                backdrop: "static",
                size: "lg",
                resolve: {
                    data: {
                        code: $state.params.code,
                        webinarId: $state.params.id
                    },
                    loadCtrl: ["$ocLazyLoad", function ($ocLazyLoad) {
                            return import(
                            /* webpackChunkName: "addWebinarRegistrants" */
                            "./addWebinarRegistrants.component").then(function (mod) { return $ocLazyLoad.load(mod.addWebinarRegistrants); });
                        }]
                }
            });
            modalInstance.result.then(function () {
                vm.dtInstance.reloadData(true);
            }).catch(angular.noop);
        };
        //------------Remove Registrants --------------------//
        vm.removeSelectedLearners = function () {
            var registrants = vm.selectedRegistrantIds();
            if (registrants.length > 0) {
                if (vm.saving)
                    return;
                vm.saving = true;
                vm.showRegistrantErrors = false;
                webinarsResource.removeRegistrants({ id: $state.params.id, activationIds: registrants }, function () {
                    for (var activation in registrants) {
                        if (registrants.hasOwnProperty(activation)) {
                            vm.learnerListModel = _.without(vm.learnerListModel, {
                                "id": registrants[activation]
                            });
                        }
                    }
                    vm.updateData(vm.learnerListModel);
                    vm.saving = false;
                    messageService.success("common.changesSaved");
                }, function (errorData) {
                    vm.saving = false;
                    messageService.error(errorData);
                });
            }
            else {
                vm.saving = false;
                vm.showRegistrantErrors = true;
            }
        };
        //-------------------Update attendance------------------//
        vm.updateAttendance = function (status) {
            var registrants = vm.selectedRegistrantIds();
            if (registrants.length > 0) {
                if (vm.saving)
                    return;
                var model = {
                    attended: status,
                    activationIds: registrants
                };
                vm.saving = true;
                vm.showRegistrantErrors = false;
                webinarsResource.updateAttendance({ id: $state.params.id }, model, function () {
                    for (var activation in registrants) {
                        if (registrants.hasOwnProperty(activation)) {
                            var learner = _.find(vm.learnerListModel, { "id": registrants[activation] });
                            learner.attended = status;
                        }
                    }
                    vm.updateData(vm.learnerListModel);
                    vm.saving = false;
                    messageService.success("common.changesSaved");
                }, function (error) {
                    vm.saving = false;
                    messageService.error(error);
                });
            }
            else {
                vm.saving = false;
                vm.showRegistrantErrors = true;
            }
        };
    }
}());
